<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Pessoa -->
    <circle cx="8" cy="5" r="3" stroke="currentColor" stroke-width="1.5" fill="none" />
    <path
      d="M2 16.5C2 13.5 4.5 11 8 11C9.5 11 10.8 11.5 11.8 12.3"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <!-- Plus -->
    <path
      d="M15 12V18M12 15H18"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts">
</script>
